// Include direct children of matching members, without pulling in unrelated
// spouses or recursively adding descendants from another gotra.
export function gotraTree(persons, gotra, caste, religion) {
  const sameGotra = persons.filter((p) => (p.gotra || "") === gotra
    && (caste === undefined || (p.caste || "") === caste)
    && (religion === undefined || (p.religion || "") === religion));
  const parents = new Set(sameGotra.map((p) => p.id));
  const children = new Set(sameGotra.flatMap((p) => p.children_ids || []));
  return persons.filter((p) => parents.has(p.id) || children.has(p.id)
    || parents.has(p.father_id) || parents.has(p.mother_id));
}
